// @flow

export type PinCommentCountUpdate = {
  type: 'PIN_UPDATE_COMMENT_COUNT',
  payload: {
    id: string,
    increment: 1 | -1,
  },
};

export function pinUpdateCommentCount(id: string, increment: 1 | -1): PinCommentCountUpdate {
  return {
    type: 'PIN_UPDATE_COMMENT_COUNT',
    payload: {
      id,
      increment,
    },
  };
}

export default null;
